'use client'

import { useAuthContext } from './Auth.context'
import { initialAuthData } from './model.ts'
import { invalidateAllServiceCache } from '@services/shared/cache.service.ts'
import { useContext } from 'react'
import { PrivyAuthContext } from './context/usePrivyAuth.hook'

export const useClearSession = () => {
  const {
    auth: [__, setAuthData],
  } = useAuthContext()
  // `PrivyAuthContext` is only defined once the lazy Web3 chunk is mounted. Before that
  // there is no Privy session in memory to end, and importing `@privy-io/react-auth`
  // here would put Privy in every route's bundle (useApi -> useClearSession).
  const privyAuth = useContext(PrivyAuthContext)

  const clearSession = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('privy_login_method')
    }
    privyAuth?.triggerLogout()
    setAuthData(initialAuthData)
    invalidateAllServiceCache()
  }

  return {
    clearSession,
  }
}
